import slugify from "@sindresorhus/slugify";
import {TOPIC_TYPE_PATHS, isTopicTypePathKey} from "../../../paths";
import type {ChecklistRelatedItem, CollectionDataResponse} from "../types";

export const buildTopicHref = (item: ChecklistRelatedItem): string => {
    const key = Number(item.topicTypeId);
    const typePath = isTopicTypePathKey(key) ? TOPIC_TYPE_PATHS[key] : "unknown";
    return `/${typePath}/${slugify(item.name)}/${item.topicId}`;
};

export const buildChecklistDocHref = (
    item: ChecklistRelatedItem,
    basePath: string,
    collection?: CollectionDataResponse,
): string => {
    const collectionSuffix = collection?.metadata?.collectionId
        ? `/utfylling/${slugify(collection.metadata.name ?? "utfylling")}/${collection.metadata.collectionId}`
        : "";
    return `${basePath}/dokument/${slugify(item.name)}/${item.topicId}${collectionSuffix}`;
};
